// @ts-nocheck
/**
 * Registry for non-serializable dialog callbacks (functions can't go into Redux).
 * Call `registerCatalogCallbacks` before `openDialog`, then the dialog reads from here.
 */

type CatalogCallbacks = {
  onConfirm?: (items: any[]) => void;
  onCancel?: () => void;
};

let _callbacks: CatalogCallbacks = {};

export function registerCatalogCallbacks(callbacks: CatalogCallbacks) {
  _callbacks = callbacks;
}

export function getCatalogCallbacks(): CatalogCallbacks {
  return _callbacks;
}

export function clearCatalogCallbacks() {
  _callbacks = {};
}
